import { RegisteredTokenDetail } from "models/factory/RegisteredTokenResponse"
import { ConfigResponse } from "models/staking/ConfigResponse"
import { TokenInfoResponse } from "models/token/TokenInfoResponse"
import { useAsset } from "provider/AssetProvider"
import { useCoinhallToken } from "provider/CoinhallTokensProvider"
import { usePagePermission } from "provider/PagePermissionProvider"
import { useWallet } from "provider/WalletProvider"
import { useNavigate } from "react-router-dom"
import { formatAddress, fromDenom, numberPendek } from "utils/Helpers"
import { showSimpleModal } from "utils/Modals"

type Props = {
    isVerified?: boolean,
    pool: number,
    tokenDetail: RegisteredTokenDetail
    config: ConfigResponse,
    tokenInfo: TokenInfoResponse,
    onShowModal: (tokenDetail: RegisteredTokenDetail, config: ConfigResponse, tokenInfo: TokenInfoResponse, pool: number) => void,
    onShowForm: (tokenDetail: RegisteredTokenDetail, config: ConfigResponse, tokenInfo: TokenInfoResponse, pool: number) => void,
}

export function TokenItem({ config, tokenInfo, tokenDetail, onShowForm, onShowModal, pool, isVerified = true }: Props) {
    const { address } = useWallet()
    const navigate = useNavigate()
    const tokens = useCoinhallToken()

    const getIcon = () => {
        if (tokenDetail?.token_address == "terra16vr6egq7p0eduy0d8jzp9gcea5v24p4ul5uky90za5052nr2gvcs5947ux")
            return "https://i.ibb.co/TqZfQZn/6995cc70-6043-46c7-90a7-8aca84122fc3.jpg"
        if (tokenDetail?.token_address == "terra1a4x7t4w7a5hwqph0q0m5maqu45j99cpkgt82rllvrh4hc6g53k7spulsqj")
            return "https://i.ibb.co.com/g4BGpG9/IMG-0646.jpg"
        if (tokenDetail?.token_address == "terra1x6e64es6yhauhvs3prvpdg2gkqdtfru840wgnhs935x8axr7zxkqzysuxz")
            return "https://i.ibb.co.com/Z6NmJj2/20240831-081220-0000.png"
        if (tokenDetail?.token_address == "terra13y0q6dxwm3h02hqdecqy2uys7d8c4rgj34dpzwk9aa4m5jknj55s3evuu7")
            return "https://i.ibb.co.com/XkcF4yK/Whats-App-Image-2025-01-14-at-17-52-42.jpg"
        if (tokenDetail?.token_address == "terra1gm4fzalxdhjt0hl398dhe9ln9ecj50m9dmr4x5558w59js02v9psqncdgd")
            return "https://i.ibb.co/D5skyJr/Historia-Nova-Token.jpg"
        if (tokenDetail?.token_address == "terra15juucad3k2npsj53crl6qhra9f65s9jkas9nzpqypj38en4ht32qczde4a")
            return "https://ipfs.bigbangx.io/ipfs/Qmc79HE9T1ovwjZKbdZXyJW8SbvGPy4oVN7aqTDxeFseP4"
        if (tokenDetail?.token_address == "terra1a8rmymsc58p9jg45p8ghy2ueqhmmhsxgd2tvuxma0pxa3g40tw8s0tjg82")
            return "https://ipfs.bigbangx.io/ipfs/QmNo8z5WmZMYRturnEJuQ3v3XLtVo5aqWui5PK7DaYwxpi"
        if (tokenDetail?.token_address == "terra1genyaw32qah4544m0sfgmchegf7emft77u7hug63cc6a72mvpntsfupzmd")
            return "https://i.ibb.co.com/cccXSrRP/IMG-20250310-191158-166.jpg"
        if (tokenDetail?.token_address == " ")
            return "https://i.ibb.co.com/Mxt8H4Dz/V-I-P-20.png"
        if (tokenDetail?.token_address == "terra1gzs0926z2u6f2w9afk6ks4z9gkjpac00x60fy9yu903qjjz6nk9qmu5jx3")
            return "https://i.ibb.co.com/bS4K3b2/giphy-1.gif"
        if (tokenDetail?.token_address == "terra16hl9mwp67l8xjy8hlhasmzldlmdpw963gmpj6e2em0g7xy4el2ys6kwtlt")
            return "https://i.ibb.co.com/Z1BRGqx2/5bd0b6696689864e7b21a285ea21f808.jpg"
        if (tokenDetail?.token_address == "terra1hwgszhekjmeqxxejen3va42efmvpfz89m4peh969sk49a9sd9ztqrec872")
            return "https://i.ibb.co.com/fYTtKzRM/d9dfca63c71e914c663bc3e87db2ab71.jpg"
        if (tokenDetail?.token_address == "terra1zra7m9w59sxwxqy8lqs3yeqleedrvtgg2qf938nk2wf8pq2ejkqsn0heln")
            return "https://i.ibb.co.com/F4kmDKJx/V-I-P-28.png"
        if (tokenDetail?.token_address == "terra1sl0cgtanapyy449h0hlmt77s8hak7caktvky8t4ct7a7kvjtyyvqzg8rv6")
            return "https://i.ibb.co.com/5hNNhy6D/VIP1-ezgif-com-resize.gif"
        if (tokenDetail?.token_address == "terra1ljyvgw50u67r3ep7pp7qexgnsgy96fl57q0suut325ehed7eal8qwdtdq4")
            return "https://i.ibb.co/fVrRDkkm/elpaco3.png"
        if (tokenDetail?.token_address == "terra1apl7g8hcfnlfhgp6xtqmszauvfpsqvmx9sq0f85xcs39uxtw6psq7d65jg")
            return "https://i.ibb.co.com/wNMq2Z86/V-I-P-21.png"
        if (tokenDetail?.token_address == "terra1wwrg00jczxf4czy4jr4wc2nvgpl4un4g8fjvm2zy54neel7ygqgsmlhhvp")
            return "https://i.ibb.co/cKy8JBbh/photo-2025-06-08-04-38-53.jpg"
        return tokens.find(e => e.id == tokenDetail.token_address)?.icon

    }

    return <li className="d-flex pb-1 mt-3">
        {
            getIcon() && <div className="avatar flex-shrink-0 me-3">
                <img src={getIcon()} />
            </div>
        }

        <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
            <div className="me-2">
                <h6 className="mb-0">
                    {tokenInfo.name} ({tokenInfo.symbol})
                    {
                        isVerified && <i onClick={() => showSimpleModal(
                            "Verified Staking Token",
                            <div className="d-flex align-items-center gap-1">
                                This token has been verified by the project owner but its not a recommendation from the platform. Stake with your own risk and always DYOR
                            </div>
                        )}
                            className="cursor-pointer bx ms-1 bx-tada-hover bx-check-shield text-success"></i>
                    }

                </h6>
                <small className="text-muted">{numberPendek(fromDenom(pool, tokenInfo.decimals))} {tokenInfo.symbol}</small>
            </div>
            <div className="user-progress">
                <small className="fw-semibold badge bg-label-success">{(Number(config?.config.apr) * 100).toFixed(2)}%</small>
            </div>
        </div>
        <div className="btn-group ms-3" role="group" aria-label="Basic example">
            <button
                disabled={!address}
                onClick={() => navigate(`/${tokenDetail.staking_address}/asset`)}
                type="button"
                className="btn btn-outline-primary">Stake</button>
            <button
                onClick={() => onShowModal(tokenDetail, config, tokenInfo, pool)}
                type="button"
                className="btn btn-primary d-block d-md-none">
                <i className="tf-icons bx bx-detail"></i>
            </button>
            <button
                onClick={() => onShowForm(tokenDetail, config, tokenInfo, pool)}
                type="button"
                className="btn btn-primary d-none d-md-block">
                <i className="tf-icons bx bx-detail"></i>
            </button>
        </div>
    </li>
}